import React from "react"
import { Container } from "react-bootstrap"
import { Helmet } from "react-helmet-async"
import { PrevetTabStateProvider } from "../hooks/prevetContext"
import { PrevetTabStateMain } from "./PrevetTabStateMain"

export function PrevetWrapper() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Helmet>
          <title>Pre-Vetting | Market Manager Platform</title>
        </Helmet>
        <Container fluid>
          <div className="main-content_inner">
            <div className="PrevetWrapper_BreadcrumbBar">
              <h4>Pre-Vetting</h4>
            </div>
            <PrevetTabStateProvider>
              <PrevetTabStateMain />
            </PrevetTabStateProvider>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}
